module.exports = __webpack_public_path__ + "assets/logo.51accb384e048b472b34e29ca121c916.png";